(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* Money */
  const formatMoney = (cents) => {
    const fmt = (window.ERCH && window.ERCH.moneyFormat) || '{{amount}}';
    const n = (cents / 100);
    const group = (v, dec, t, d) => {
      const [i, f] = v.toFixed(dec).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (f ? d + f : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: group(n, 2, ',', '.'),
      amount_no_decimals: group(n, 0, ',', '.'),
      amount_with_comma_separator: group(n, 2, '.', ','),
      amount_no_decimals_with_comma_separator: group(n, 0, '.', ','),
      amount_with_space_separator: group(n, 2, ' ', ','),
      amount_no_decimals_with_space_separator: group(n, 0, ' ', ','),
      amount_with_apostrophe_separator: group(n, 2, "'", '.')
    }[k] || group(n, 2, ',', '.')));
  };

  /* Header offset for mobile drawer */
  const setHeaderVar = () => {
    const h = $('[data-header]');
    if (h) document.documentElement.style.setProperty('--header-bottom', h.getBoundingClientRect().bottom + 'px');
  };
  setHeaderVar();
  addEventListener('resize', setHeaderVar);
  addEventListener('scroll', setHeaderVar, { passive: true });

  /* Reveal on scroll */
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;
  $$('[data-reveal]').forEach((el, i) => {
    el.style.transitionDelay = (i % 4) * 70 + 'ms';
    io ? io.observe(el) : el.classList.add('is-in');
  });

  /* Quantity buttons */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty]');
    if (!b) return;
    const input = b.parentElement.querySelector('input');
    const min = parseInt(input.min || '0', 10);
    input.value = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(b.dataset.qty, 10));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Collection sort */
  const sort = $('[data-sort]');
  if (sort) sort.addEventListener('change', () => {
    const u = new URL(location.href);
    u.searchParams.set('sort_by', sort.value);
    u.searchParams.delete('page');
    location.href = u.toString();
  });

  /* Product variants */
  $$('[data-product]').forEach((root) => {
    const jsonEl = $('[data-product-json]', root);
    if (!jsonEl) return;
    const product = JSON.parse(jsonEl.textContent);
    const idInput = $('[data-variant-id]', root);
    const priceEl = $('[data-price]', root);
    const compareEl = $('[data-compare]', root);
    const addBtn = $('[data-add]', root);

    const selected = () => [1, 2, 3].map((i) => {
      const c = $(`input[data-option="${i}"]:checked`, root);
      return c ? c.value : null;
    }).filter((v) => v !== null);

    const update = () => {
      const opts = selected();
      opts.forEach((v, i) => { const l = $(`[data-opt-value="${i + 1}"]`, root); if (l) l.textContent = v; });
      const v = product.variants.find((x) => x.options.every((o, i) => o === opts[i]));
      if (!v) {
        addBtn.disabled = true; addBtn.textContent = 'Боломжгүй';
        return;
      }
      idInput.value = v.id;
      priceEl.textContent = formatMoney(v.price);
      if (v.compare_at_price && v.compare_at_price > v.price) {
        compareEl.textContent = formatMoney(v.compare_at_price); compareEl.hidden = false;
      } else { compareEl.hidden = true; }
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Сагсанд нэмэх' : 'Дууссан';
      const u = new URL(location.href); u.searchParams.set('variant', v.id);
      history.replaceState({}, '', u);
      if (v.featured_media) {
        const m = $(`[data-media-id="${v.featured_media.id}"]`, root);
        const g = $('[data-gallery]', root);
        if (m && g) {
          if (g.scrollWidth > g.clientWidth) g.scrollTo({ left: m.offsetLeft - g.offsetLeft, behavior: 'smooth' });
          else if (m !== g.firstElementChild) g.prepend(m);
        }
      }
    };
    $$('input[data-option]', root).forEach((i) => i.addEventListener('change', update));
  });

  /* AJAX add to cart */
  const toast = $('[data-toast]');
  let toastTimer;
  const showToast = (text) => {
    if (!toast) return;
    $('[data-toast-text]', toast).textContent = text;
    toast.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-on'), 3500);
  };
  const refreshCount = async () => {
    try {
      const r = await fetch(window.ERCH.routes.cart, { headers: { Accept: 'application/json' } });
      const c = await r.json();
      $$('[data-cart-count]').forEach((el) => {
        el.textContent = c.item_count;
        el.classList.add('bump'); setTimeout(() => el.classList.remove('bump'), 300);
      });
    } catch (e) { /* ignore */ }
  };
  $$('form[data-ajax-cart]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      if (!window.fetch || !window.ERCH) return;
      e.preventDefault();
      const btn = $('[data-add]', form);
      const msg = $('[data-form-msg]', form);
      if (msg) msg.hidden = true;
      btn.disabled = true;
      const label = btn.textContent;
      btn.textContent = '…';
      try {
        const r = await fetch(window.ERCH.routes.cart_add, {
          method: 'POST', body: new FormData(form), headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        });
        const data = await r.json();
        if (!r.ok) throw new Error(data.description || data.message || 'Алдаа гарлаа');
        showToast('Сагсанд нэмэгдлээ ✓');
        refreshCount();
      } catch (err) {
        if (msg) { msg.textContent = err.message; msg.hidden = false; }
      } finally {
        btn.disabled = false; btn.textContent = label;
      }
    });
  });
})();
